"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationPricing',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        approve: '通过',
        reject: '驳回',
        withdraw: '撤回'
      }[value] || value;
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationPricingListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('商品名称', '提交销售定价').then(function (_ref) {
        var value = _ref.value;
        var now = new Date();
        var pad = function pad(n) {
          return String(n).padStart(2, '0');
        };
        var effectiveFrom = "".concat(now.getFullYear(), "-").concat(pad(now.getMonth() + 1), "-").concat(pad(now.getDate()), " ").concat(pad(now.getHours()), ":").concat(pad(now.getMinutes()), ":00");
        (0, _decoration.decorationPricingSaveApi)({
          productId: 94,
          productName: value || 'E2E定价商品',
          pricingType: 'sale',
          salePrice: 199,
          effectiveFrom: effectiveFrom
        }).then(function () {
          _this2.$message.success('已提交');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationPricingActionApi)(row.pricing.id, {
          action: action
        }).then(function () {
          _this3.$message.success('已更新');
          _this3.loadCurrent();
        });
      }).catch(function () {});
    }
  }
};